import { render } from "./LawOffice.vue?vue&type=template&id=edfa6aea"
import script from "./LawOffice.vue?vue&type=script&lang=js"
export * from "./LawOffice.vue?vue&type=script&lang=js"

import "./LawOffice.vue?vue&type=style&index=0&id=edfa6aea&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__